import {Component} from "react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, isSearchError: false, analyticsClient: props.analyticsClient, message: "", stackTrace: "" };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error, isSearchError: ErrorBoundary.isAPIGroupSearchResultError(error), message: error.message, stackTrace: error.stack };
    }

    static isAPIGroupSearchResultError(error) {
        if (error !== null) {
            return (error.message === "Cannot read property 'name' of undefined")
        }
        return false
    }

    componentDidCatch(error, errorInfo) {
        this.state.analyticsClient.sendOperationalEvent({
            source: 'ErrorBoundary',
            action: 'caughtError', // required
            actionSubject: 'graphiQLError', // required
            attributes: {
                isApiGroupSearchResultError: this.state.isSearchError,
                selectedApiGroup: this.state.selectedService
            }
        });
    }

    render() {
        if (this.state.hasError) {
            if (this.state.isSearchError) {
                return <div>
                    <h1>Something went wrong.</h1>
                    <p>We (the AGG team) have been experimenting around with GraphiQL and looks like something broke :(</p>
                    <p>Please ping us at #help-graphql-gateway and let us know about it</p>
                    <p>Most likely you had an API Group selected and tried to search through a type that didn't exist
                        in that API Group. This is an experimental feature, if you want to look for that type again
                        please refresh and search by selecting "ALL" for the API Group</p>
                </div>
            } else {
                return <div>
                    <h1>Something went wrong.</h1>
                    <p>We (the AGG team) have been experimenting around with GraphiQL and looks like something broke :(</p>
                    <p>Please ping us at #help-graphql-gateway and let us know about it</p>
                    <h2>Error message</h2>
                    <code>{this.state.message} </code>
                    <h2>Stack trace:</h2>
                    <code>{this.state.stackTrace}</code>
                    <h2>Query:</h2>
                    <code>{this.props.query}</code>

                </div>
            }
        }

        return this.props.children;
    }
}

export default ErrorBoundary